// extracted by mini-css-extract-plugin
module.exports = {"mapMarker":"Marker_mapMarker__I5Xa7","active":"Marker_active__3henY","disabled":"Marker_disabled__5AsjU","visited":"Marker_visited__TCDl0"};